/** @jsx jsx */
import { jsx } from "theme-ui"
import {
  websites_Polska,
  websites_Czechy,
  websites_Hiszpania,
  websites_Niemcy,
} from "../util/const"
import CookieConsent from "react-cookie-consent"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

export const getUrlWithUTM_SOURCE = url => {
  if (url.endsWith("?")) {
    return `${url}utm_source=${process.env.GATSBY_PARKING_SIMPLE_URL}`
  } else if (url.endsWith("/")) {
    return `${url}utm_source=${process.env.GATSBY_PARKING_SIMPLE_URL}`
  }
  return `${url}/?utm_source=${process.env.GATSBY_PARKING_SIMPLE_URL}`
}

const getWebsiteList = websites => {
  return websites
    .filter(item => process.env.GATSBY_PARKING_SIMPLE_URL !== item)
    .map(website =>
      website.disabled ? (
        <span className="disabled" key={website.name}>
          {website.name.replace("Parking", "Parkingi lotnisko")}
        </span>
      ) : (
        <a
          target={"_blank"}
          rel="noreferrer"
          className="footer-link"
          href={getUrlWithUTM_SOURCE(website.url)}
          key={website.name}
        >
          {website.name.replace("Parking", "Parkingi lotnisko")}
        </a>
      ),
    )
}
const Footer = () => {
  const handleClickFooterAd = () => {
    // eslint-disable-next-line no-undef
    const adBtn = document?.getElementById("ad-footer")
    // eslint-disable-next-line no-undef
    if (window && window.gtag && typeof window.gtag === "function") {
      // eslint-disable-next-line no-undef
      window.gtag("event", "ad-click", {
        event_category: "ad-click",
        event_label: adBtn?.querySelector("img")?.title,
      })
    }
  }
  return (
    <footer
      className="site-footer"
      sx={{
        bg: "siteColor",
      }}
    >
      <Link to="/parkingi-przy-lotniskach">
        <h3 className="color-white">Lista parkingów przy lotniskach</h3>
      </Link>
      <div className="footer">
        <div className="website-list">
          <span className="website-list-countryName">Polska ⬇️</span>
          {getWebsiteList(websites_Polska)}
        </div>
        <div className="website-list">
          <span className="website-list-countryName">Czechy ⬇️</span>
          {getWebsiteList(websites_Czechy)}
        </div>
        <div className="website-list">
          <span className="website-list-countryName">Niemcy ⬇️</span>
          {getWebsiteList(websites_Niemcy)}
        </div>
        <div className="website-list">
          <span className="website-list-countryName">Hiszpania ⬇️</span>
          {getWebsiteList(websites_Hiszpania)}
        </div>
      </div>
      <div className="container">
        <a href={`/`} key={"siteURL"} className="color-white">
          <h3>
            {`www.${
              process.env.GATSBY_PARKING_SIMPLE_URL
            }  © ${new Date().getFullYear()}`}
          </h3>
        </a>
      </div>
      <div className="container">
        <Link className={"color-white"} to={`/polityka-prywatnosci`}>
          Polityka Prywatności
        </Link>
        {" | "}
        <Link className={"color-white"} to={`/regulamin`}>
          Regulamin
        </Link>{" "}
        {" | "}
        <Link className={"color-white"} to={`/rodo`} rel="noopener noreferrer">
          RODO
        </Link>
        {" | "}
        <Link
          className={"color-white"}
          to={`/jak-zarezerwowac-parking-przy-lotnisku`}
          rel="noopener noreferrer"
        >
          Jak zarezerwować parking ?
        </Link>
        {" | "}
        <Link className={"color-white"} to={`/kontakt`}>
          Kontakt
        </Link>
      </div>
      <a
        className="margin-top-xl"
        onClick={handleClickFooterAd}
        href={`https://wyszukiwarkawakacji.pl/wakacje/last-minute/?utm_source=${process.env.GATSBY_PARKING_SIMPLE_URL}`}
        target="_blank"
      >
        <StaticImage
          title="baner wyszukiwarkawakacji.pl"
          src={"../../static/assets/wyszukiwarka_baner.jpg"}
          alt={"baner wyszukiwarkawakacji.pl"}
          className="featured-image"
        />
      </a>
      <CookieConsent
        buttonClasses="nety_accept_button"
        buttonText="Akceptuję"
        style={{ fontSize: "1em" }}
      >
        <p style={{ fontSize: "1.3em" }}>
          Ten serwis wykorzystuje pliki cookies
        </p>
        <p>
          Serwis wykorzystuje pliki cookies m.in. w celu poprawienia jej
          dostępności, personalizacji, obsługi kont użytkowników czy aby zbierać
          dane, dotyczące ruchu na stronie. Każdy może sam decydować o tym czy
          dopuszcza pliki cookies, ustawiając odpowiednio swoją przeglądarkę.
          <br />
          <br />
          Więcej informacji znajdziesz w{" "}
          <a
            href={`/polityka-prywatnosci`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Polityce Prywatności
          </a>{" "}
          i{" "}
          <a href={`/regulamin`} target="_blank" rel="noopener noreferrer">
            Regulaminie
          </a>
          .
        </p>
      </CookieConsent>
    </footer>
  )
}
export default Footer
